import {
  ApplicationConfig,
  importProvidersFrom,
  provideZoneChangeDetection,
  provideAppInitializer,
  inject,
} from '@angular/core'

import { provideRouter, withNavigationErrorHandler } from '@angular/router'

import { provideHttpClient, withInterceptors } from '@angular/common/http'

import { routes } from './app.routes'

import { authInterceptor } from './interceptors/auth.interceptor'

import { TranslateService } from './core/services/translate.service'

import { I18nModule } from './core/i18n/i18n.module'

import { providePrimeNG } from 'primeng/config'

import { MessageService } from 'primeng/api'

import Aura from '@primeuix/themes/aura'

import { GlobalFontAwesomeModule } from './core/modules/font-awesome.module'

import { languageInterceptor } from './interceptors/language.interceptor'
import { initializeBranding } from './services/branding.service'

export function initializeTranslate(): Promise<void> {
  const translateService = inject(TranslateService)

  return translateService.init()
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),

    provideRouter(
      routes,

      withNavigationErrorHandler((error) => {
        console.error('[Router] Navigation error', error)
      }),
    ),

    provideHttpClient(withInterceptors([authInterceptor, languageInterceptor])),

    TranslateService,

    importProvidersFrom(I18nModule),

    provideAppInitializer(initializeTranslate),

    provideAppInitializer(initializeBranding),

    importProvidersFrom(GlobalFontAwesomeModule),

    providePrimeNG({
      theme: {
        preset: Aura,

        options: {
          darkModeSelector: false,
        },
      },
    }),

    MessageService,
  ],
}
